import { ContractPropertyName } from '../../../constants';
import { Types } from '../../constants';
import { Helper } from '../Helper';
export class SetProcessedTransactionHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.createStructuredStorage({
            prefix: ContractPropertyName.processedTransactions,
            type: Types.SetStorage,
        }));
        sb.emitSysCall(node, 'System.ExecutionEngine.GetScriptContainer');
        sb.emitSysCall(node, 'Neo.Transaction.GetHash');
        sb.emitHelper(node, options, sb.helpers.wrapBuffer);
        sb.emitPushBoolean(node, true);
        sb.emitHelper(node, options, sb.helpers.wrapBoolean);
        sb.emitHelper(node, options, sb.helpers.setStructuredStorage({
            type: Types.SetStorage,
            keyType: undefined,
            knownKeyType: Types.Buffer,
        }));
    }
}

//# sourceMappingURL=SetProcessedTransactionHelper.js.map
